"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const typography = {
    "weightNormal": "normal",
    "weightMedium": "500",
    "weightBold": "bold"
};
exports.default = typography;
